module.exports = __webpack_public_path__ + "media/placeholder_movil_en.9e8ae0f7.mp4";